var c2dHandler = require('../c2dHandler');

var vgIs = document.createElement('vg-is');
var vgIsHolder = document.createElement('vg-is-orig');
if (vgIsHolder && vgIsHolder.style) {
  vgIsHolder.style.display = 'none';
}

function replace(node, innerHTML) {
  var parentNode = node.parentNode;
  if (parentNode && ['VG-IS-ORIG', 'GU-SC-ORIG'].indexOf((parentNode.tagName || '').toUpperCase()) === -1) {
    var newNode: any = vgIs.cloneNode(true);
    var origHolder = vgIsHolder.cloneNode(true);
    newNode.innerHTML = innerHTML;
    newNode.onclick = c2dHandler.onClick;
    newNode.origNode = parentNode.replaceChild(newNode, node);
    origHolder.appendChild(node);
    newNode.appendChild(origHolder);
  }
}

function revert(node) {
  if (node.origNode) {
    node.parentNode.replaceChild(node.origNode, node);
  }
  return node.origNode;
}

module.exports = {
  replace: replace,
  revert: revert
};